import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { Sparkles } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import { ShortcutCard } from "@/components/admin/SectionShell";

export const Route = createFileRoute("/admin/ai/")({
  component: AiDashboard,
});

function AiDashboard() {
  const { data } = useQuery({
    queryKey: ["admin-ai-overview"],
    queryFn: async () => {
      const { count } = await (supabase as any).from("sophia_keywords").select("id", { count: "exact", head: true });
      return { sophia: count ?? 0 };
    },
  });
  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
      <ShortcutCard to="/admin/ai/sophia" icon={Sparkles} title="Sophia" value={data?.sophia ?? "—"} hint="palavras-chave cadastradas" />
    </div>
  );
}
